import InputEmailWithDomains from '@portalterreno/nextjs-client/components/InputEmailWithDomains';
import InputName from '@portalterreno/nextjs-client/components/InputName';
import InputPhone from '@portalterreno/nextjs-client/components/InputPhone';
import React from 'react';

import ContentWrapper from './ContentWrapper';

export type ContentProps = React.HTMLAttributes<HTMLDivElement>;

const Content: React.FC<ContentProps> = ({ ...rest }) => {
  return (
    <ContentWrapper {...rest}>
      <InputName />
      <InputEmailWithDomains />
      <InputPhone />
    </ContentWrapper>
  );
};

export default Content;
